import React, { useState } from "react";
import ContactsSimpleSearch from "../../../../Contacts/ContactsSimpleSearch";
import Contacts from "../../../../Contacts/Contacts";
import MyModal from "../../../../Common/MyModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleXmark,
  faMinus,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import ContactsList from "../../../../Contacts/ContactsList";
import { Modal, Offcanvas } from "react-bootstrap";
import MyCollapse from "../../../../Common/MyCollapse";

const emptyArray: string[] = [];

export interface ContactInputProps {
  values: any[];
  onChange: (values: any[]) => void;
  isMultiple?: boolean;
  hideList?: boolean;
  modalAsOffcanvas?: boolean;
}

export default function ContactInput({
  values,
  onChange,
  isMultiple,
  hideList,
  modalAsOffcanvas = false,
}: ContactInputProps) {
  const [show, setShow] = useState(false);
  const [tobeRemoved, setTobeRemoved] = useState<string[]>([]);
  const [selectedContacts, setSelectedContacts] = useState<string[]>([]);
  const PickerShell = (modalAsOffcanvas ? Offcanvas : Modal) as any;
  const PickerHeader = modalAsOffcanvas ? Offcanvas.Header : Modal.Header;
  const PickerBody = modalAsOffcanvas ? Offcanvas.Body : Modal.Body;
  const PickerTitle = modalAsOffcanvas ? Offcanvas.Title : Modal.Title;

  const [filter, setFilter] = useState([
    // Word search
    {
      values: [""],
      is_or: true,
      fields: [],
      formats: ["card", "primary"],
      order: 0,
      operator: "prefix",
    },
    // Status filter
    {
      fields: ["status"],
      formats: [],
      isOr: false,
      offset: "0",
      offsetFrom: "fixed",
      offsetType: "positive",
      offsetUnit: "day",
      operator: "is",
      order: 0,
      thread: "CurrentThread",
      timeZone: "",
      timeZoneFrom: "fixed",
      valueId: "",
      values: ["active"],
      valueType: "fixed",
    },
  ]);
  return (
    <>
      <div className="p-2 bg-light rounded-2">
        {values && values.length > 0 && !hideList && (
          <MyCollapse heading={`${values.length || "No"} contacts selected.`}>
            <div className="mb-2">
              <div className="d-flex gap-2 flex-wrap align-items-center mb-2">
                <strong>Selected Contacts</strong>
                {tobeRemoved.length > 0 && (
                  <button
                    className="btn btn-outline-danger border-0 "
                    onClick={() => {
                      onChange(values.filter((v) => !tobeRemoved.includes(v)));
                      setTobeRemoved([]);
                    }}
                  >
                    Remove selected
                  </button>
                )}
              </div>
              <Contacts
                filters={undefined}
                fields={undefined}
                useSearchOptions={true}
                includeContacts={values}
                ignoreContacts={undefined}
                ignoreSets={undefined}
                contactSet={undefined}
                contactSets={emptyArray}
                strictCriteria={undefined}
                doNotUseSets={undefined}
                contactButton={
                  isMultiple
                    ? undefined
                    : (c: any) => (
                        <button
                          className="btn btn-sm btn-outline-danger border-0"
                          onClick={() => {
                            onChange(values.filter((v) => v !== c.uuid));
                          }}
                        >
                          <FontAwesomeIcon icon={faMinus} />
                        </button>
                      )
                }
                notDraggable={undefined}
                onDrop={undefined}
                allContactsButton={undefined}
                isModal={undefined}
                showContactFields={undefined}
                setSelectedContacts={isMultiple ? setTobeRemoved : undefined}
              />
            </div>
          </MyCollapse>
        )}
        {(isMultiple || values.length === 0) && (
          <button className="btn btn-link p-0" onClick={() => setShow(true)}>
            Select Contacts
          </button>
        )}
      </div>
      <PickerShell
        show={show}
        onHide={() => {
          setShow(false);
        }}
        {...(modalAsOffcanvas
          ? { placement: "end", style: { width: "800px" } }
          : { size: "xl" })}
      >
        <PickerHeader closeButton>
          <PickerTitle>Select Contacts</PickerTitle>
        </PickerHeader>
        <PickerBody>
          <div style={{ minHeight: 720 }}>
            <div className="bg-colored-reverse p-3 rounded-3 d-flex flex-wrap align-items-end mb-3 gap-2">
              <ContactsSimpleSearch filter={filter} setFilter={setFilter} />
            </div>
            <Contacts
              filters={filter}
              fields={undefined}
              useSearchOptions={true}
              includeContacts={undefined}
              ignoreContacts={values}
              ignoreSets={undefined}
              contactSet={undefined}
              contactSets={emptyArray}
              strictCriteria={undefined}
              doNotUseSets={undefined}
              contactButton={
                isMultiple
                  ? undefined
                  : (c: any) => (
                      <button
                        className="btn btn-sm btn-colored"
                        onClick={() => {
                          console.log(c);
                          onChange([c.uuid]);
                          setShow(false);
                        }}
                      >
                        Select
                      </button>
                    )
              }
              notDraggable={undefined}
              onDrop={undefined}
              allContactsButton={undefined}
              isModal={undefined}
              showContactFields={undefined}
              setSelectedContacts={isMultiple ? setSelectedContacts : undefined}
            />
          </div>
          {isMultiple && (
            <div className="d-flex justify-content-end mt-2 ">
              <button
                className="btn btn-colored"
                onClick={() => {
                  onChange([...values, ...selectedContacts]);
                  setShow(false);
                }}
              >
                Save
              </button>
            </div>
          )}
        </PickerBody>
      </PickerShell>
    </>
  );
}
